/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateClient = `subscription OnCreateClient {
  onCreateClient {
    id
    code
    name
    description
    logo
    website
    email
    address
    phoneno
    accounts {
      items {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      nextToken
    }
    features {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onUpdateClient = `subscription OnUpdateClient {
  onUpdateClient {
    id
    code
    name
    description
    logo
    website
    email
    address
    phoneno
    accounts {
      items {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      nextToken
    }
    features {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onDeleteClient = `subscription OnDeleteClient {
  onDeleteClient {
    id
    code
    name
    description
    logo
    website
    email
    address
    phoneno
    accounts {
      items {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      nextToken
    }
    features {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onCreateAccount = `subscription OnCreateAccount {
  onCreateAccount {
    id
    code
    name
    description
    logo
    website
    email
    address
    phoneno
    claims {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    features {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onUpdateAccount = `subscription OnUpdateAccount {
  onUpdateAccount {
    id
    code
    name
    description
    logo
    website
    email
    address
    phoneno
    claims {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    features {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onDeleteAccount = `subscription OnDeleteAccount {
  onDeleteAccount {
    id
    code
    name
    description
    logo
    website
    email
    address
    phoneno
    claims {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    features {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onCreateUser = `subscription OnCreateUser {
  onCreateUser {
    id
    email
    name
    clients {
      items {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      nextToken
    }
    accounts {
      items {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      nextToken
    }
    appSettings {
      items {
        key
        value
        owner
      }
      nextToken
    }
    isApproved
    claims {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onUpdateUser = `subscription OnUpdateUser {
  onUpdateUser {
    id
    email
    name
    clients {
      items {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      nextToken
    }
    accounts {
      items {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      nextToken
    }
    appSettings {
      items {
        key
        value
        owner
      }
      nextToken
    }
    isApproved
    claims {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onDeleteUser = `subscription OnDeleteUser {
  onDeleteUser {
    id
    email
    name
    clients {
      items {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      nextToken
    }
    accounts {
      items {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      nextToken
    }
    appSettings {
      items {
        key
        value
        owner
      }
      nextToken
    }
    isApproved
    claims {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onCreateAppSetting = `subscription OnCreateAppSetting($owner: String) {
  onCreateAppSetting(owner: $owner) {
    key
    value
    owner
  }
}
`;
export const onUpdateAppSetting = `subscription OnUpdateAppSetting($owner: String) {
  onUpdateAppSetting(owner: $owner) {
    key
    value
    owner
  }
}
`;
export const onDeleteAppSetting = `subscription OnDeleteAppSetting($owner: String) {
  onDeleteAppSetting(owner: $owner) {
    key
    value
    owner
  }
}
`;
export const onCreateEvent = `subscription OnCreateEvent {
  onCreateEvent {
    id
    customer {
      id
      code
      name
      description
      logo
      website
      email
      address
      phoneno
      accounts {
        nextToken
      }
      features {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    name
    description
    type
    sport
    property
    fixture
    account {
      id
      code
      name
      description
      logo
      website
      email
      address
      phoneno
      claims {
        nextToken
      }
      features {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    bitrateMbps
    bugRequired
    outputs {
      items {
        id
        claimsCanAccess
        claimsCanEdit
      }
      nextToken
    }
    input {
      id
      name
      description
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    actions {
      items {
        id
        setupOffsetMs
        actionType
        claimsCanAccess
        claimsCanEdit
        version
      }
      nextToken
    }
    lineupTime
    startTime
    endTime
    status
    timeExtensionMin
    audioMapping {
      items {
        id
        channelNo
        nameFieldL
        nameFieldR
        active
        claimsCanAccess
        claimsCanEdit
      }
      nextToken
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onUpdateEvent = `subscription OnUpdateEvent {
  onUpdateEvent {
    id
    customer {
      id
      code
      name
      description
      logo
      website
      email
      address
      phoneno
      accounts {
        nextToken
      }
      features {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    name
    description
    type
    sport
    property
    fixture
    account {
      id
      code
      name
      description
      logo
      website
      email
      address
      phoneno
      claims {
        nextToken
      }
      features {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    bitrateMbps
    bugRequired
    outputs {
      items {
        id
        claimsCanAccess
        claimsCanEdit
      }
      nextToken
    }
    input {
      id
      name
      description
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    actions {
      items {
        id
        setupOffsetMs
        actionType
        claimsCanAccess
        claimsCanEdit
        version
      }
      nextToken
    }
    lineupTime
    startTime
    endTime
    status
    timeExtensionMin
    audioMapping {
      items {
        id
        channelNo
        nameFieldL
        nameFieldR
        active
        claimsCanAccess
        claimsCanEdit
      }
      nextToken
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onDeleteEvent = `subscription OnDeleteEvent {
  onDeleteEvent {
    id
    customer {
      id
      code
      name
      description
      logo
      website
      email
      address
      phoneno
      accounts {
        nextToken
      }
      features {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    name
    description
    type
    sport
    property
    fixture
    account {
      id
      code
      name
      description
      logo
      website
      email
      address
      phoneno
      claims {
        nextToken
      }
      features {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    bitrateMbps
    bugRequired
    outputs {
      items {
        id
        claimsCanAccess
        claimsCanEdit
      }
      nextToken
    }
    input {
      id
      name
      description
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    actions {
      items {
        id
        setupOffsetMs
        actionType
        claimsCanAccess
        claimsCanEdit
        version
      }
      nextToken
    }
    lineupTime
    startTime
    endTime
    status
    timeExtensionMin
    audioMapping {
      items {
        id
        channelNo
        nameFieldL
        nameFieldR
        active
        claimsCanAccess
        claimsCanEdit
      }
      nextToken
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onCreateEventOutputMap = `subscription OnCreateEventOutputMap {
  onCreateEventOutputMap {
    id
    event {
      id
      customer {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      name
      description
      type
      sport
      property
      fixture
      account {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      bitrateMbps
      bugRequired
      outputs {
        nextToken
      }
      input {
        id
        name
        description
        claimsCanAccess
        claimsCanEdit
        version
      }
      actions {
        nextToken
      }
      lineupTime
      startTime
      endTime
      status
      timeExtensionMin
      audioMapping {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    output {
      id
      name
      description
      events {
        nextToken
      }
      outputType
      ottPlatform
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    claimsCanAccess
    claimsCanEdit
  }
}
`;
export const onUpdateEventOutputMap = `subscription OnUpdateEventOutputMap {
  onUpdateEventOutputMap {
    id
    event {
      id
      customer {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      name
      description
      type
      sport
      property
      fixture
      account {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      bitrateMbps
      bugRequired
      outputs {
        nextToken
      }
      input {
        id
        name
        description
        claimsCanAccess
        claimsCanEdit
        version
      }
      actions {
        nextToken
      }
      lineupTime
      startTime
      endTime
      status
      timeExtensionMin
      audioMapping {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    output {
      id
      name
      description
      events {
        nextToken
      }
      outputType
      ottPlatform
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    claimsCanAccess
    claimsCanEdit
  }
}
`;
export const onDeleteEventOutputMap = `subscription OnDeleteEventOutputMap {
  onDeleteEventOutputMap {
    id
    event {
      id
      customer {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      name
      description
      type
      sport
      property
      fixture
      account {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      bitrateMbps
      bugRequired
      outputs {
        nextToken
      }
      input {
        id
        name
        description
        claimsCanAccess
        claimsCanEdit
        version
      }
      actions {
        nextToken
      }
      lineupTime
      startTime
      endTime
      status
      timeExtensionMin
      audioMapping {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    output {
      id
      name
      description
      events {
        nextToken
      }
      outputType
      ottPlatform
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    claimsCanAccess
    claimsCanEdit
  }
}
`;
export const onCreateEventAudioChannel = `subscription OnCreateEventAudioChannel {
  onCreateEventAudioChannel {
    id
    channelNo
    nameFieldL
    nameFieldR
    languageL {
      id
      name
      isoCode1
      isoCode2t
      isoCode2b
      isoCode3
    }
    languageR {
      id
      name
      isoCode1
      isoCode2t
      isoCode2b
      isoCode3
    }
    active
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
  }
}
`;
export const onUpdateEventAudioChannel = `subscription OnUpdateEventAudioChannel {
  onUpdateEventAudioChannel {
    id
    channelNo
    nameFieldL
    nameFieldR
    languageL {
      id
      name
      isoCode1
      isoCode2t
      isoCode2b
      isoCode3
    }
    languageR {
      id
      name
      isoCode1
      isoCode2t
      isoCode2b
      isoCode3
    }
    active
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
  }
}
`;
export const onDeleteEventAudioChannel = `subscription OnDeleteEventAudioChannel {
  onDeleteEventAudioChannel {
    id
    channelNo
    nameFieldL
    nameFieldR
    languageL {
      id
      name
      isoCode1
      isoCode2t
      isoCode2b
      isoCode3
    }
    languageR {
      id
      name
      isoCode1
      isoCode2t
      isoCode2b
      isoCode3
    }
    active
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
  }
}
`;
export const onCreateEventAction = `subscription OnCreateEventAction {
  onCreateEventAction {
    id
    setupOffsetMs
    actionType
    configWowza {
      id
      type
      incomingTieline
      server
      targets {
        nextToken
      }
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    configRoute {
      id
      source {
        id
        name
        description
        originRouterGroup
        originRouterSourceId
        claimsCanAccess
        claimsCanEdit
        version
      }
      destinations {
        nextToken
      }
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    configPlayout {
      id
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    configRecording {
      id
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    configDownlink {
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    configMaintenance {
      id
      serversToRestart
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onUpdateEventAction = `subscription OnUpdateEventAction {
  onUpdateEventAction {
    id
    setupOffsetMs
    actionType
    configWowza {
      id
      type
      incomingTieline
      server
      targets {
        nextToken
      }
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    configRoute {
      id
      source {
        id
        name
        description
        originRouterGroup
        originRouterSourceId
        claimsCanAccess
        claimsCanEdit
        version
      }
      destinations {
        nextToken
      }
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    configPlayout {
      id
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    configRecording {
      id
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    configDownlink {
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    configMaintenance {
      id
      serversToRestart
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onDeleteEventAction = `subscription OnDeleteEventAction {
  onDeleteEventAction {
    id
    setupOffsetMs
    actionType
    configWowza {
      id
      type
      incomingTieline
      server
      targets {
        nextToken
      }
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    configRoute {
      id
      source {
        id
        name
        description
        originRouterGroup
        originRouterSourceId
        claimsCanAccess
        claimsCanEdit
        version
      }
      destinations {
        nextToken
      }
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    configPlayout {
      id
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    configRecording {
      id
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    configDownlink {
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    configMaintenance {
      id
      serversToRestart
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onCreateInput = `subscription OnCreateInput {
  onCreateInput {
    id
    name
    description
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onUpdateInput = `subscription OnUpdateInput {
  onUpdateInput {
    id
    name
    description
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onDeleteInput = `subscription OnDeleteInput {
  onDeleteInput {
    id
    name
    description
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onCreateOutput = `subscription OnCreateOutput {
  onCreateOutput {
    id
    name
    description
    events {
      items {
        id
        claimsCanAccess
        claimsCanEdit
      }
      nextToken
    }
    outputType
    ottPlatform
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onUpdateOutput = `subscription OnUpdateOutput {
  onUpdateOutput {
    id
    name
    description
    events {
      items {
        id
        claimsCanAccess
        claimsCanEdit
      }
      nextToken
    }
    outputType
    ottPlatform
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onDeleteOutput = `subscription OnDeleteOutput {
  onDeleteOutput {
    id
    name
    description
    events {
      items {
        id
        claimsCanAccess
        claimsCanEdit
      }
      nextToken
    }
    outputType
    ottPlatform
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onCreateRouter = `subscription OnCreateRouter {
  onCreateRouter {
    id
    name
    description
    client {
      id
      code
      name
      description
      logo
      website
      email
      address
      phoneno
      accounts {
        nextToken
      }
      features {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onUpdateRouter = `subscription OnUpdateRouter {
  onUpdateRouter {
    id
    name
    description
    client {
      id
      code
      name
      description
      logo
      website
      email
      address
      phoneno
      accounts {
        nextToken
      }
      features {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onDeleteRouter = `subscription OnDeleteRouter {
  onDeleteRouter {
    id
    name
    description
    client {
      id
      code
      name
      description
      logo
      website
      email
      address
      phoneno
      accounts {
        nextToken
      }
      features {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onCreateRouterGroup = `subscription OnCreateRouterGroup {
  onCreateRouterGroup {
    id
    name
    sources {
      items {
        id
        name
        description
        originRouterGroup
        originRouterSourceId
        claimsCanAccess
        claimsCanEdit
        version
      }
      nextToken
    }
    destinations {
      items {
        id
        name
        description
        originRouterGroup
        originRouterDestinationId
        claimsCanAccess
        claimsCanEdit
        version
      }
      nextToken
    }
    router {
      id
      name
      description
      client {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onUpdateRouterGroup = `subscription OnUpdateRouterGroup {
  onUpdateRouterGroup {
    id
    name
    sources {
      items {
        id
        name
        description
        originRouterGroup
        originRouterSourceId
        claimsCanAccess
        claimsCanEdit
        version
      }
      nextToken
    }
    destinations {
      items {
        id
        name
        description
        originRouterGroup
        originRouterDestinationId
        claimsCanAccess
        claimsCanEdit
        version
      }
      nextToken
    }
    router {
      id
      name
      description
      client {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onDeleteRouterGroup = `subscription OnDeleteRouterGroup {
  onDeleteRouterGroup {
    id
    name
    sources {
      items {
        id
        name
        description
        originRouterGroup
        originRouterSourceId
        claimsCanAccess
        claimsCanEdit
        version
      }
      nextToken
    }
    destinations {
      items {
        id
        name
        description
        originRouterGroup
        originRouterDestinationId
        claimsCanAccess
        claimsCanEdit
        version
      }
      nextToken
    }
    router {
      id
      name
      description
      client {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onCreateRouterSource = `subscription OnCreateRouterSource {
  onCreateRouterSource {
    id
    name
    description
    router {
      id
      name
      description
      client {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    originRouterGroup
    originRouterSourceId
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onUpdateRouterSource = `subscription OnUpdateRouterSource {
  onUpdateRouterSource {
    id
    name
    description
    router {
      id
      name
      description
      client {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    originRouterGroup
    originRouterSourceId
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onDeleteRouterSource = `subscription OnDeleteRouterSource {
  onDeleteRouterSource {
    id
    name
    description
    router {
      id
      name
      description
      client {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    originRouterGroup
    originRouterSourceId
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onCreateRouterDestination = `subscription OnCreateRouterDestination {
  onCreateRouterDestination {
    id
    name
    description
    router {
      id
      name
      description
      client {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    originRouterGroup
    originRouterDestinationId
    routedSource {
      id
      name
      description
      router {
        id
        name
        description
        claimsCanAccess
        claimsCanEdit
        version
      }
      originRouterGroup
      originRouterSourceId
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onUpdateRouterDestination = `subscription OnUpdateRouterDestination {
  onUpdateRouterDestination {
    id
    name
    description
    router {
      id
      name
      description
      client {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    originRouterGroup
    originRouterDestinationId
    routedSource {
      id
      name
      description
      router {
        id
        name
        description
        claimsCanAccess
        claimsCanEdit
        version
      }
      originRouterGroup
      originRouterSourceId
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onDeleteRouterDestination = `subscription OnDeleteRouterDestination {
  onDeleteRouterDestination {
    id
    name
    description
    router {
      id
      name
      description
      client {
        id
        code
        name
        description
        logo
        website
        email
        address
        phoneno
        claimsCanAccess
        claimsCanEdit
        version
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    originRouterGroup
    originRouterDestinationId
    routedSource {
      id
      name
      description
      router {
        id
        name
        description
        claimsCanAccess
        claimsCanEdit
        version
      }
      originRouterGroup
      originRouterSourceId
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    claimsCanAccess
    claimsCanEdit
    lastUpdatedBy {
      id
      email
      name
      clients {
        nextToken
      }
      accounts {
        nextToken
      }
      appSettings {
        nextToken
      }
      isApproved
      claims {
        nextToken
      }
      claimsCanAccess
      claimsCanEdit
      lastUpdatedBy {
        id
        email
        name
        isApproved
        claimsCanAccess
        claimsCanEdit
        version
      }
      version
    }
    version
  }
}
`;
export const onCreateClaim = `subscription OnCreateClaim {
  onCreateClaim {
    id
    code
    name
    description
    feature {
      id
      code
      name
      description
      claims {
        nextToken
      }
    }
  }
}
`;
export const onUpdateClaim = `subscription OnUpdateClaim {
  onUpdateClaim {
    id
    code
    name
    description
    feature {
      id
      code
      name
      description
      claims {
        nextToken
      }
    }
  }
}
`;
export const onDeleteClaim = `subscription OnDeleteClaim {
  onDeleteClaim {
    id
    code
    name
    description
    feature {
      id
      code
      name
      description
      claims {
        nextToken
      }
    }
  }
}
`;
export const onCreateFeature = `subscription OnCreateFeature {
  onCreateFeature {
    id
    code
    name
    description
    claims {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
  }
}
`;
export const onUpdateFeature = `subscription OnUpdateFeature {
  onUpdateFeature {
    id
    code
    name
    description
    claims {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
  }
}
`;
export const onDeleteFeature = `subscription OnDeleteFeature {
  onDeleteFeature {
    id
    code
    name
    description
    claims {
      items {
        id
        code
        name
        description
      }
      nextToken
    }
  }
}
`;
export const onCreateLanguage = `subscription OnCreateLanguage {
  onCreateLanguage {
    id
    name
    isoCode1
    isoCode2t
    isoCode2b
    isoCode3
  }
}
`;
export const onUpdateLanguage = `subscription OnUpdateLanguage {
  onUpdateLanguage {
    id
    name
    isoCode1
    isoCode2t
    isoCode2b
    isoCode3
  }
}
`;
export const onDeleteLanguage = `subscription OnDeleteLanguage {
  onDeleteLanguage {
    id
    name
    isoCode1
    isoCode2t
    isoCode2b
    isoCode3
  }
}
`;

export const onInputStatusNotification = `subscription OnInputStatusNotification($inputId: ID) {
  onInputStatusNotification(inputId: $inputId) {
    inputId
    type
    status
    timestamp
    dataJson
  }
}
`;
